import { DataModuleWithViewItems, NavigationItem } from '@osos/shared/types';

export namespace NavigationStateActions {
  export class FetchItemsPinnedToSidebarV2 {
    static readonly type = '[NavigationState] Fetch Sidebar Views V2';
  }
  export class FetchSidebarStatusCounts {
    static readonly type = '[NavigationState] Fetch Sidebar Status Counts';
  }
  export class UpsertNavigationItem {
    static readonly type = '[NavigationState] Upsert Navigation Item';
    constructor(
      public navItem: NavigationItem,
      public module?: DataModuleWithViewItems,
    ) {}
  }

  export class UpdateNavigationItem {
    static readonly type = '[NavigationState] Update Navigation Item';
    constructor(
      public navItem: NavigationItem,
      public moduleId?: string,
    ) {}
  }

  export class RemoveNavigationItem {
    static readonly type = '[NavigationState] Remove Navigation Item';
    constructor(
      public navItemId: string,
      public moduleId?: string,
    ) {}
  }
}
